// A failed fetch must deny role-gated routes rather than leave them spinning, so the flags a gate
// reads are stated as false instead of left absent.
const emptyAccountPayload = { isAmbassador: false };

export const fetchAccountData = () => dispatch => {
  dispatch({
    type: 'FETCHING_ACCOUNT_DATA'
  });
  return fetch('/api/account', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin'
  })
    .then(res => res.text().then(text => ({ ok: res.ok, status: res.status, text })))
    .then(({ ok, status, text }) => {
      let response;
      try {
        response = text ? JSON.parse(text) : {};
      } catch (e) {
        console.warn('fetchAccountData: response was not valid JSON', status, e);
        dispatch({
          type: 'SAVE_ACCOUNT_DATA',
          accountData: emptyAccountPayload
        });
        return;
      }
      if (!ok) {
        console.warn('fetchAccountData: HTTP error', status, response && response.message);
        dispatch({
          type: 'SAVE_ACCOUNT_DATA',
          accountData: emptyAccountPayload
        });
        return;
      }
      if (response.status === 'success') {
        dispatch({
          type: 'SAVE_ACCOUNT_DATA',
          accountData: response.data
        });
      } else {
        console.warn(`failed fetching accountData: ${response.message}`);
        dispatch({
          type: 'SAVE_ACCOUNT_DATA',
          accountData: emptyAccountPayload
        });
      }
    })
    .catch(ex => {
      console.warn('failed fetching accountData', ex);
      dispatch({
        type: 'SAVE_ACCOUNT_DATA',
        accountData: emptyAccountPayload
      });
    });
};

export const removeCreditPayment = paymentId => dispatch =>
  dispatch({
    type: 'REMOVE_PENDING_CREDIT',
    paymentId
  });

export const checkInBooking = (bookingId, token, formData) => dispatch =>
  fetch(`/api/account/booking/${bookingId}/check-in`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      ...formData,
      _token: token
    })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'SAVE_ACCOUNT_DATA',
          accountData: response.data
        });
        return { status: 'success', message: response.message, data: response.data };
      }
      return { status: 'failed', message: response.message, data: response.data };
    })
    .catch(error => {
      console.warn('failed fetching user', error);
      return { status: 'failed', message: 'There was an error while saving your experience details.' };
    });

export const getNavbarConfig = async () => {
  try {
    const response = await fetch(`/api/get-navbar-config`);

    // Check if the response is OK (status 2xx)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const navbarConfig = await response.json();

    // Ensure the navbarConfig has a 'data' field before accessing it
    return navbarConfig?.data || [];

  } catch (e) {
    console.error("ERROR fetching navbar config:", e);
    return [];  // Return an empty array on error
  }
};

/** Cash kitty / additional costs — same source as public calculator (GET /api/kitty-config). */
export const getKittyConfig = async () => {
  try {
    const response = await fetch('/api/kitty-config');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const payload = await response.json();
    return payload?.data || null;
  } catch (e) {
    console.error('ERROR fetching kitty config:', e);
    return null;
  }
};
